<template>
    <div>


        <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsBilanturi" :allowColumnResizing="true"
            key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'" :show-borders="true"
            :syncLookupFilterValues="false" :filter-sync-enabled="true" show-column-lines="false"
            :allowMerging="'Cells'" height="100%" class="grid theme-dependent" @exporting="onExporting"
            :hover-state-enabled="true" @selection-changed="handleRowSelection">
            <DxSelection mode="single" />
            <DxScrolling :mode="'virtual'" />
            <DxColumnChooser :enabled="true" />
            <DxSorting mode="multiple" />
            <DxHeaderFilter :visible="true" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="350">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Nume" :editor-options="{ width: 510 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="Explicatie" :editor-options="{ height: 80, width: 510 }" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxSearchPanel :visible="true" placeholder="Cauta Bilant" />
            <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
            <DxGridToolbar>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <dx-button icon="plus" type="success" @click="onAddClick" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="exportButton" />
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" />
                <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
            </DxGridToolbar>
            <!-- <DxStateStoring :enabled="true" :filterValue="false" storage-key="ConBilanturi" /> -->
            <DxColumn data-field="Cod" />
            <DxColumn data-field="Nume" />
            <DxColumn data-field="TipCalcul" />
            <DxColumn data-field="Explicatie" />

        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="600" :height="330">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare</div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxFormItem :col-span="2" :col-count="2" item-type="group">
                        <DxFormItem dataField="Cod" :editor-options="{ width: 250 }" />
                        <DxFormItem dataField="Nume" :editor-options="{ width: 250 }" />
                        <DxFormItem dataField="Explicatie" :editor-options="{ width: 250 }" />
                        <DxFormItem dataField="TipCalcul" :editor-options="{ width: 250 }" />
                    </DxFormItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>

    </div>
</template>
<script lang="ts">
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import { locale, loadMessages } from 'devextreme/localization';
import {
    DxItem as DxGridToolbarItem,
    DxLookup,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxEditing,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxForm as DxFormGrid,
    DxScrolling,
    DxHeaderFilter
} from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmContacts from '@/services/Comercial/CrmContacts';
import router from '@/router';
import ConBilanturi from '@/services/Contabilitate/ConBilanturi';
export default defineComponent({
    components: {
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxEditing,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxScrollView,
        DxLookup,
        DxColumnChooser,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxSearchPanel,
        DxMasterDetail,
        DxPopup,
        DxToolbarItem,
        DxFormGrid,
        DxGridToolbarItem,
        DxScrolling,
        DxHeaderFilter,
        DxDropDownButton,
        DxFormItem,
    },

    data() {
        return {
            dsBilanturi: {} as ODataStore,
            isModalVisible: false,
            isPanelOpened: ref(false),
            dataGrid: ref<DxDataGrid | null>(null),
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {
                return `
                <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white; 
                font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
                Editare
                </div>
            `;
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            formData: {
                Cod: '',
                Nume: '',
                Explicatie: '',
                TipCalcul: '',
            },
            selectedBilant: {
                Cod: '',
                Nume: '',
                Explicatie: '',
                TipCalcul: '',
            },

        };
    },
    methods: {
        createODataContext() {
            this.dsBilanturi = new ODataStore({
                url: AppSetting.API_Url_Contabilitate + 'CON_Bilanturi',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });
        },
        onSaveAdd() {
            if (!this.formData.Cod || this.formData.Cod.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
                return;
            }
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            console.log(this.formData);
            const body = this.formData;
            ConBilanturi.save(body).then((response) => {
                this.isModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);
                this.formData = {
                    Cod: '',
                    Nume: '',
                    Explicatie: '',
                    TipCalcul: '',
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 1000);
            });
            this.createODataContext();
        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            notify('Datele au fost actualizate cu succes!', 'success', 1000);
        },
        onSaveEdit() {
            const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
            savePromise.then((result) => {
                this.dataGridRef?.instance?.saveEditData();
            }).catch((error) => {
                console.error(error);
            });
            this.createODataContext();
        },
        onCancel() {
            this.isModalVisible = false;
            this.$refs.dataGrid?.instance?.cancelEditData();
        },
        onRowRemoving() {
            notify('Datele au fost șterse cu succes!', 'success', 1000);
        },
        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('CrmContacts.pdf');
                });
            } else if (e.format === 'xlsx') {

                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('preturi');

                exportDataGridExcel({
                    component: e.component,
                    worksheet,
                    autoFilterEnabled: true,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CrmContacts.xlsx');
                    });
                });
                e.cancel = true;
            }

        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGrid?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        handleRowSelection(e) {
            const selectedRow = e.selectedRowsData[0];
            this.$emit('select-bilant', selectedRow);
        },
        onCancelEdit() {
            this.dataGrid?.instance?.cancelEditData();
        },
    },
    mounted() {
        this.createODataContext();
        this.dataGrid = this.$refs.dataGrid as DxDataGrid;
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });

        locale('ro');
    },
});
</script>
<style scoped lang="scss"></style>